import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
function DashboardMockup() {
  return <div className="w-full bg-white rounded-2xl border border-carbon-geo shadow-xl shadow-carbon-deep/5 overflow-hidden" data-id="element-650">
      {/* Title bar */}
      <div className="flex items-center gap-2 px-5 py-3.5 border-b border-carbon-geo bg-gray-50/80" data-id="element-651">
        <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-652" />
        <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-653" />
        <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-654" />
        <span className="ml-3 text-xs font-medium text-carbon-mid/50" data-id="element-655">
          CarbonSafe Dashboard
        </span>
      </div>

      <div className="p-5 space-y-5" data-id="element-656">
        {/* Top stats row */}
        <div className="grid grid-cols-3 gap-3" data-id="element-657">
          <div className="rounded-xl bg-carbon-bright/5 border border-carbon-geo p-3" data-id="element-658">
            <p className="text-[10px] font-semibold text-carbon-mid/60 uppercase tracking-wider" data-id="element-659">
              Total Emissions
            </p>
            <p className="text-lg font-bold text-carbon-deep mt-1" data-id="element-660">
              12,847{' '}
              <span className="text-xs font-medium text-carbon-mid" data-id="element-661">tCO₂e</span>
            </p>
          </div>
          <div className="rounded-xl bg-carbon-bright/5 border border-carbon-geo p-3" data-id="element-662">
            <p className="text-[10px] font-semibold text-carbon-mid/60 uppercase tracking-wider" data-id="element-663">
              Reduction
            </p>
            <p className="text-lg font-bold text-carbon-bright mt-1" data-id="element-664">
              -23%{' '}
              <span className="text-xs font-medium text-carbon-mid" data-id="element-665">YoY</span>
            </p>
          </div>
          <div className="rounded-xl bg-carbon-bright/5 border border-carbon-geo p-3" data-id="element-666">
            <p className="text-[10px] font-semibold text-carbon-mid/60 uppercase tracking-wider" data-id="element-667">
              Offsets
            </p>
            <p className="text-lg font-bold text-carbon-deep mt-1" data-id="element-668">
              3,200{' '}
              <span className="text-xs font-medium text-carbon-mid" data-id="element-669">
                credits
              </span>
            </p>
          </div>
        </div>

        {/* Chart area */}
        <div className="rounded-xl border border-carbon-geo p-4" data-id="element-670">
          <p className="text-xs font-semibold text-carbon-mid/60 uppercase tracking-wider mb-4" data-id="element-671">
            Monthly Emissions Trend
          </p>
          <div className="flex items-end gap-2 h-28" data-id="element-672">
            {[65, 58, 72, 50, 45, 55, 40, 38, 42, 35, 30, 28].map((h, i) => <div key={i} className="flex-1 flex flex-col items-center gap-1" data-id="element-673">
                <div className="w-full rounded-t-sm transition-all" style={{
              height: `${h}%`,
              backgroundColor: i >= 9 ? '#52B788' : i >= 6 ? '#6BCB77' : '#B7DFCA'
            }} data-id="element-674" />
              </div>)}
          </div>
          <div className="flex justify-between mt-2" data-id="element-675">
            <span className="text-[9px] text-carbon-mid/40" data-id="element-676">Jan</span>
            <span className="text-[9px] text-carbon-mid/40" data-id="element-677">Jun</span>
            <span className="text-[9px] text-carbon-mid/40" data-id="element-678">Dec</span>
          </div>
        </div>

        {/* Bottom row */}
        <div className="grid grid-cols-2 gap-3" data-id="element-679">
          <div className="rounded-xl border border-carbon-geo p-3" data-id="element-680">
            <p className="text-[10px] font-semibold text-carbon-mid/60 uppercase tracking-wider mb-2" data-id="element-681">
              By Scope
            </p>
            <div className="space-y-2" data-id="element-682">
              <div data-id="element-683">
                <div className="flex justify-between text-[10px] mb-1" data-id="element-684">
                  <span className="text-carbon-mid" data-id="element-685">Scope 1</span>
                  <span className="font-semibold text-carbon-deep" data-id="element-686">18%</span>
                </div>
                <div className="h-1.5 bg-carbon-geo rounded-full overflow-hidden" data-id="element-687">
                  <div className="h-full bg-carbon-deep rounded-full" style={{
                  width: '18%'
                }} data-id="element-688" />
                </div>
              </div>
              <div data-id="element-689">
                <div className="flex justify-between text-[10px] mb-1" data-id="element-690">
                  <span className="text-carbon-mid" data-id="element-691">Scope 2</span>
                  <span className="font-semibold text-carbon-deep" data-id="element-692">32%</span>
                </div>
                <div className="h-1.5 bg-carbon-geo rounded-full overflow-hidden" data-id="element-693">
                  <div className="h-full bg-carbon-mid rounded-full" style={{
                  width: '32%'
                }} data-id="element-694" />
                </div>
              </div>
              <div data-id="element-695">
                <div className="flex justify-between text-[10px] mb-1" data-id="element-696">
                  <span className="text-carbon-mid" data-id="element-697">Scope 3</span>
                  <span className="font-semibold text-carbon-deep" data-id="element-698">50%</span>
                </div>
                <div className="h-1.5 bg-carbon-geo rounded-full overflow-hidden" data-id="element-699">
                  <div className="h-full bg-carbon-bright rounded-full" style={{
                  width: '50%'
                }} data-id="element-700" />
                </div>
              </div>
            </div>
          </div>
          <div className="rounded-xl border border-carbon-geo p-3" data-id="element-701">
            <p className="text-[10px] font-semibold text-carbon-mid/60 uppercase tracking-wider mb-2" data-id="element-702">
              Compliance
            </p>
            <div className="space-y-1.5" data-id="element-703">
              <div className="flex items-center gap-2" data-id="element-704">
                <div className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-705" />
                <span className="text-[10px] text-carbon-mid" data-id="element-706">
                  GHG Protocol
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-707">
                <div className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-708" />
                <span className="text-[10px] text-carbon-mid" data-id="element-709">CSRD Ready</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-710">
                <div className="w-2 h-2 rounded-full bg-carbon-olive" data-id="element-711" />
                <span className="text-[10px] text-carbon-mid" data-id="element-712">ISO 14064</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-713">
                <div className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-714" />
                <span className="text-[10px] text-carbon-mid" data-id="element-715">SEC Climate</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function ProductShowcase() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const bullets = ['Real-time emissions monitoring across all scopes', 'Automated data ingestion from 500+ sources', 'Audit-ready reports for every major framework', 'Scenario modeling for reduction pathways', 'Team collaboration with role-based access'];
  return <section ref={ref} className="w-full bg-white py-20 sm:py-28 border-t border-b border-carbon-geo" data-id="element-716">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-717">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-718">
          {/* Left: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-719">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-carbon-deep tracking-tight leading-tight" data-id="element-720">
              Comprehensive carbon
              <span className="text-carbon-bright" data-id="element-721"> intelligence </span>
              platform
            </h2>
            <p className="mt-6 text-lg text-carbon-mid leading-relaxed" data-id="element-722">
              CarbonSafe brings together emissions data, compliance frameworks,
              and offset management into a single platform, giving your
              sustainability team the clarity and confidence to act.
            </p>

            <ul className="mt-8 space-y-4" data-id="element-723">
              {bullets.map(item => <li key={item} className="flex items-start gap-3" data-id="element-724">
                  <CheckCircle2Icon className="w-5 h-5 text-carbon-bright mt-0.5 flex-shrink-0" data-id="element-725" />
                  <span className="text-carbon-mid" data-id="element-726">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right: Dashboard Mockup */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-727">
            <DashboardMockup data-id="element-728" />
          </motion.div>
        </div>
      </div>
    </section>;
}